export const UK_LOCALE = 'en-GB';
export const DE_LOCALE = 'de';
